<script>
import DOMUtils from '@/utils/DOMUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import EnvironmentUtils from '@/utils/environmentUtils'
import Calendar from '@/components/Calendar'
import EventsServices from '@/services/events'

const REF_CALENDAR = 'calendar';

export default
{
    name: 'events',

    created ()
    {
        EventsServices.fetchEvents(EnvironmentUtils.cityId).then(async events =>
        {
           await this.$store.commit('events/updateEventList', events)

            console.log('Setting events seen to all available events id')
            LocalStorageUtils.eventsSeen = this.$store.state.events.eventList.map(e => e.id)
        })
    },

    render () 
    {
        return (
            <div id='events-view'>
                <Calendar id='calendar' ref={REF_CALENDAR} events={this.$store.state.events.eventList} />
            </div>
        )
    },

    updated ()
    {
        for (let editor of this.calendar.$el.querySelectorAll('.event-item .wrapper')) DOMUtils.invertTextColorsIfNeeded(editor)
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
        calendar ()
        {
            return this.$refs[REF_CALENDAR]
        }
    },

    beforeRouteEnter (to, from, next)
    {
        next(vm =>
        {
            if (LocalStorageUtils.useIntensiveAnimations && vm.calendar != undefined)
            {
                DOMUtils.animateCSS(vm.calendar.$el, 'zoomIn', '0.3s')
            }
            
        })
    },

    methods:
    {
    },

    components:
    {
        Calendar
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#events-view
{
    #calendar
    {
        margin-top: 4vh;

        .OnDesktop({
            margin-top: 0;
            border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
        });
    }

    #bottom-color-cover
    {
        position: fixed;
        z-index: -1;
        width: 100%;
        height: calc(var(--theme-horizontal-menu-height) + 10vh);
        bottom: 0;
        background: var(--theme-accent-color);
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Events.vue